import { trackEvent, AnalyticsCategory } from '@nx-frontend/shared/analytics';

export function trackClickRelated(type: 'promptSuggestion' | 'historyItem') {
  const label = type === 'promptSuggestion' ? 'New Chat Conversation' : 'Existing Chat Conversation';
  trackEvent('Related Prompt Click', AnalyticsCategory.AI_ASSISTANT, label);
}

export function trackChatOpen(from: 'floatingIcon' | 'sidebarMenu' | 'notesList') {
  const labels = {
    floatingIcon: 'Floating Icon',
    sidebarMenu: 'Sidebar Menu',
    notesList: 'Notes List',
  };
  const label = labels[from] ? labels[from] : 'Unknown';
  trackEvent('AI Chat Open', AnalyticsCategory.AI_ASSISTANT, label);
}

export function trackInfoMenuOpen() {
  trackEvent('AI Chat Info Icon Click', AnalyticsCategory.AI_ASSISTANT, '');
}

export function trackThreadDelete() {
  trackEvent('Existing AI Chat Delete', AnalyticsCategory.AI_ASSISTANT, '');
}

export function trackSubmitMessageFeedback() {
  trackEvent('AI Chat Feedback Click', AnalyticsCategory.AI_ASSISTANT, '');
}

export function trackCopyAIResponseToClipboard() {
  trackEvent('Copy AI Chat Response Click', AnalyticsCategory.AI_ASSISTANT, '');
}

export function trackAddAIResponseToPage() {
  trackEvent('Added AI Chat Response to Page Click', AnalyticsCategory.AI_ASSISTANT, '');
}
